import { Text, vModelText, vModelSelect, vModelRadio, vModelCheckbox, vModelDynamic } from "vue";
import "../node_modules/.pnpm/case@1.6.3/node_modules/case/dist/Case.js";
import { createAutoBuildingObject, indent, voidElements, serializeJs } from "@histoire/shared";
import { C as Case } from "../_virtual/Case.js";
async function generateSourceCode(variant) {
  var _a, _b, _c, _d, _e, _f;
  const vnode = (_d = (_c = (_b = variant.slots()).default) == null ? void 0 : _c.call(_b, { state: (_a = variant.state) != null ? _a : {} })) != null ? _d : [];
  const list = Array.isArray(vnode) ? vnode : [vnode];
  const lines = [];
  for (const n in list) {
    const vnode2 = list[n];
    lines.push(...(await printVNode(vnode2, (_f = (_e = variant.state) == null ? void 0 : _e._hPropState) == null ? void 0 : _f[n])).lines);
  }
  return lines.join("\n");
}
async function printVNode(vnode, propsOverrides = null) {
  var _a, _b, _c;
  if (vnode.type === Text) {
    return {
      lines: [vnode.children],
      isText: true
    };
  }
  const lines = [];
  if (typeof vnode.type === "object" || typeof vnode.type === "string") {
    let genDirective = function(dirName, dir, valueCode = null) {
      var _a2;
      let modifiers = "";
      for (const key in dir.modifiers) {
        if (dir.modifiers[key]) {
          modifiers += `.${key}`;
        }
      }
      let arg = "";
      if (dir.arg) {
        arg = `:${dir.arg}`;
      }
      if (valueCode) {
        valueCode = valueCode.replace(/^\$(setup|props|data)\./g, "");
      }
      const valueLines = valueCode ? [valueCode] : serializeAndCleanJs(dir.value);
      const attr = [];
      const dirAttr = `v-${dirName}${arg}${modifiers}="`;
      if (valueLines.length > 1) {
        attr.push(`${dirAttr}${valueLines[0]}`);
        attr.push(...valueLines.slice(1, valueLines.length - 1));
        attr.push(`${valueLines[valueLines.length - 1]}"`);
        multilineAttrs = true;
      } else {
        attr.push(`${dirAttr}${(_a2 = valueLines[0]) != null ? _a2 : ""}"`);
      }
      attrs.push(attr);
    }, addAttr = function(prop, value) {
      var _a2, _b2, _c2;
      if (typeof value !== "string" || ((_a2 = vnode.dynamicProps) == null ? void 0 : _a2.includes(prop))) {
        let directive = ":";
        if (prop.startsWith("on")) {
          directive = "@";
        }
        const arg = directive === "@" ? `${prop[2].toLowerCase()}${prop.slice(3)}` : prop;
        const vmodelListener = `onUpdate:${prop}`;
        if (directive === ":" && ((_b2 = vnode.dynamicProps) == null ? void 0 : _b2.includes(vmodelListener))) {
          skipProps.push(vmodelListener);
          const listener = vnode.props[vmodelListener];
          const listenerSource = listener.toString();
          let valueCode;
          const result = /\(\$event\) => (.*?) = \$event/.exec(listenerSource);
          if (result) {
            valueCode = result[1];
          }
          const modifiersKey = `${prop === "modelValue" ? "model" : prop}Modifiers`;
          const modifiers = (_c2 = vnode.props[modifiersKey]) != null ? _c2 : {};
          skipProps.push(modifiersKey);
          genDirective("model", {
            arg: prop === "modelValue" ? null : prop,
            modifiers,
            value
          }, valueCode);
          return;
        }
        if (typeof value === "undefined") {
          return;
        }
        let serialized;
        if (typeof value === "string" && value.startsWith("{{") && value.endsWith("}}")) {
          serialized = cleanupExpression(value.substring(2, value.length - 2).trim()).split("\n");
        } else if (typeof value === "function") {
          let code = cleanupExpression(value.toString().replace(/'/g, "\\'").replace(/"/g, "'"));
          const testResult = /function ([^\s]+)\(/.exec(code);
          if (testResult) {
            serialized = [testResult[1]];
          } else {
            if (code.startsWith("($event) => ")) {
              code = code.substring("($event) => ".length);
            }
            serialized = code.split("\n");
          }
        } else {
          serialized = serializeAndCleanJs(value);
        }
        if (serialized.length > 1) {
          multilineAttrs = true;
          const indented = [`${directive}${arg}="${serialized[0]}`];
          indented.push(...serialized.slice(1, serialized.length - 1));
          indented.push(`${serialized[serialized.length - 1]}"`);
          attrs.push(indented);
        } else {
          attrs.push([`${directive}${arg}="${serialized[0]}"`]);
        }
      } else {
        attrs.push([`${prop}="${value}"`]);
      }
    };
    if (((_a = vnode.type) == null ? void 0 : _a.__asyncLoader) && !vnode.type.__asyncResolved) {
      await vnode.type.__asyncLoader();
    }
    const attrs = [];
    let multilineAttrs = false;
    const skipProps = [
      "key"
    ];
    if (vnode.dirs) {
      for (const dir of vnode.dirs) {
        if (dir.dir === vModelText || dir.dir === vModelSelect || dir.dir === vModelRadio || dir.dir === vModelCheckbox || dir.dir === vModelDynamic) {
          const listenerKey = `onUpdate:${(_b = dir.arg) != null ? _b : "modelValue"}`;
          const listener = vnode.props[listenerKey];
          let valueCode = null;
          if (listener) {
            skipProps.push(listenerKey);
            const listenerSource = listener.toString();
            const result = /\(\$event\) => (.*?) = \$event/.exec(listenerSource);
            if (result) {
              valueCode = result[1];
            }
          }
          genDirective("model", dir, valueCode);
        } else if (dir.instance._ || dir.instance.$) {
          const target = (_c = dir.instance.$) != null ? _c : dir.instance._;
          let dirName;
          for (const directives of [target.directives, target.appContext.directives]) {
            for (const key in directives) {
              if (directives[key] === dir.dir) {
                dirName = key;
                break;
              }
            }
            if (dirName)
              break;
          }
          if (dirName) {
            genDirective(dirName, dir);
          }
        }
      }
    }
    for (const prop in vnode.props) {
      if (skipProps.includes(prop) || propsOverrides && prop in propsOverrides) {
        continue;
      }
      const value = vnode.props[prop];
      addAttr(prop, value);
    }
    if (propsOverrides) {
      for (const prop in propsOverrides) {
        addAttr(prop, propsOverrides[prop]);
      }
    }
    if (attrs.length > 1) {
      multilineAttrs = true;
    }
    const tagName = getTagName(vnode);
    let isChildText = false;
    const childLines = [];
    if (typeof vnode.children === "string") {
      if (tagName === "pre") {
        childLines.push(vnode.children);
      } else {
        childLines.push(...vnode.children.split("\n"));
      }
      isChildText = true;
    } else if (Array.isArray(vnode.children)) {
      let isAllChildText;
      for (const child of vnode.children) {
        const result = await printVNode(child);
        if (result.isText) {
          if (isAllChildText === void 0) {
            isAllChildText = true;
          }
          const text = result.lines[0];
          if (!childLines.length || /^\s/.test(text)) {
            childLines.push(text.trim());
          } else {
            childLines[childLines.length - 1] += text;
          }
        } else {
          if (isAllChildText === void 0) {
            isAllChildText = false;
          }
          childLines.push(...result.lines);
        }
      }
      if (isAllChildText !== void 0) {
        isChildText = isAllChildText;
      }
    }
    if (vnode.children && typeof vnode.children === "object" && !Array.isArray(vnode.children)) {
      for (const key in vnode.children) {
        if (typeof vnode.children[key] === "function") {
          const autoObject = createAutoBuildingObject((key2) => `{{ ${key2} }}`, (target, p) => {
            if (p === "__v_isRef") {
              return () => false;
            }
          });
          const children = vnode.children[key](autoObject.proxy);
          const slotLines = [];
          for (const child of children) {
            slotLines.push(...(await printVNode(child)).lines);
          }
          const slotProps = Object.keys(autoObject.cache);
          if (slotProps.length) {
            childLines.push(`<template #${key}="{ ${slotProps.join(", ")} }">`);
            childLines.push(...indent(slotLines));
            childLines.push("</template>");
          } else if (key === "default") {
            childLines.push(...slotLines);
          } else {
            childLines.push(`<template #${key}>`);
            childLines.push(...indent(slotLines));
            childLines.push(`</template>`);
          }
        }
      }
    }
    const tag = [`<${tagName}`];
    if (multilineAttrs) {
      for (const attrLines of attrs) {
        tag.push(...indent(attrLines));
      }
      if (childLines.length > 0) {
        tag.push(">");
      }
    } else {
      if (attrs.length === 1) {
        tag[0] += ` ${attrs[0]}`;
      }
      if (childLines.length > 0) {
        tag[0] += ">";
      }
    }
    const isVoid = voidElements.includes(tagName.toLowerCase());
    if (childLines.length > 0) {
      if (childLines.length === 1 && tag.length === 1 && !attrs.length && isChildText) {
        lines.push(`${tag[0]}${childLines[0]}</${tagName}>`);
      } else {
        lines.push(...tag);
        lines.push(...indent(childLines));
        lines.push(`</${tagName}>`);
      }
    } else if (tag.length > 1) {
      lines.push(...tag);
      lines.push(isVoid ? ">" : "/>");
    } else {
      lines.push(`${tag[0]}${isVoid ? "" : " /"}>`);
    }
  } else if ((vnode == null ? void 0 : vnode.shapeFlag) & 1 << 4) {
    for (const child of vnode.children) {
      lines.push(...(await printVNode(child)).lines);
    }
  }
  return {
    lines
  };
}
function getTagName(vnode) {
  var _a, _b, _c, _d, _e;
  if (typeof vnode.type === "string") {
    return vnode.type;
  } else if ((_a = vnode.type) == null ? void 0 : _a.__asyncResolved) {
    const asyncComp = (_b = vnode.type) == null ? void 0 : _b.__asyncResolved;
    return (_c = asyncComp.name) != null ? _c : getNameFromFile(asyncComp.__file);
  } else if ((_d = vnode.type) == null ? void 0 : _d.name) {
    return vnode.type.name;
  } else if ((_e = vnode.type) == null ? void 0 : _e.__file) {
    return getNameFromFile(vnode.type.__file);
  }
  return "Anonymous";
}
function getNameFromFile(file) {
  const parts = /([^/]+)\.vue$/.exec(file);
  if (parts) {
    return Case.exports.pascal(parts[1]);
  }
  return "Anonymous";
}
function serializeAndCleanJs(value) {
  const isAutoBuildingObject = !!(value == null ? void 0 : value.__autoBuildingObject);
  const result = serializeJs(value);
  if (isAutoBuildingObject) {
    return [cleanupExpression(result.__autoBuildingObjectGetKey)];
  } else {
    return cleanupExpression(result).split("\n");
  }
}
function cleanupExpression(expr) {
  return expr.replace(/\$setup\./g, "");
}
export { generateSourceCode, getTagName };
